import { Link } from 'react-router-dom';
import { Phone, MapPin, ExternalLink, MessageCircle } from 'lucide-react';
import BrandName from '../BrandName';
import { STORE_ADDRESS, STORE_MAPS_URL, STORE_PHONE } from '../../lib/constants';

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#09090B] border-t-2 border-red-600 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <BrandName size="text-3xl" className="mb-2 block" />
            <p translate="no" className="text-white text-xs uppercase tracking-widest font-medium mb-3">Sua Jornada. Nossa Peça</p>
            <p className="text-zinc-500 text-sm">Especializada em peças e acessórios para motocicletas com as melhores marcas do mercado.</p>
          </div>
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Contato</h3>
            <div className="space-y-3">
              <a href={`https://wa.me/${STORE_PHONE}`} target="_blank" rel="noopener noreferrer"
                className="flex items-center text-[#25D366] hover:text-[#20BA5C] transition-colors text-sm gap-2 font-semibold" data-testid="footer-whatsapp">
                <MessageCircle className="h-4 w-4" /> (86) 9 9816-6143
              </a>
              <a href={STORE_MAPS_URL} target="_blank" rel="noopener noreferrer"
                className="flex items-center text-zinc-400 hover:text-red-500 transition-colors text-sm gap-2" data-testid="footer-maps">
                <MapPin className="h-4 w-4" /> {STORE_ADDRESS}
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Navegação</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-zinc-400 hover:text-red-500 transition-colors text-sm">Início</Link>
              <Link to="/produtos" className="block text-zinc-400 hover:text-red-500 transition-colors text-sm">Produtos</Link>
              <Link to="/produtos?promocao=true" className="block text-zinc-400 hover:text-red-500 transition-colors text-sm">Promoções</Link>
              <Link to="/politica-de-privacidade" className="block text-zinc-400 hover:text-red-500 transition-colors text-sm">Políticas</Link>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-zinc-800 text-center">
          <p translate="no" className="text-zinc-600 text-xs">&copy; {new Date().getFullYear()} MOTOVELOZ. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
